import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { DEMO_PERSONAS, type DemoPersonaId } from '@/clients/onboarding/demoPersonas';

interface DemoPersonaPickerProps {
  onSelect: (personaId: DemoPersonaId) => void;
  disabled?: boolean;
}

const DemoPersonaPicker: React.FC<DemoPersonaPickerProps> = ({ onSelect, disabled = false }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled}
          className="h-9 border-dashed border-cyan-400/70 text-cyan-700 hover:bg-cyan-50 hover:text-cyan-800"
          data-analytics-ignore="true"
        >
          Load demo persona
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuLabel>Internal demo only</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {DEMO_PERSONAS.map((persona) => (
          <DropdownMenuItem
            key={persona.id}
            className="flex cursor-pointer flex-col items-start gap-0.5 py-2"
            onSelect={() => onSelect(persona.id)}
          >
            <span className="text-sm font-medium text-foreground">{persona.label}</span>
            <span className="text-xs text-muted-foreground">{persona.description}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DemoPersonaPicker;
